var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBgImgFull = function SvgBgImgFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 677,
    height: 677,
    fill: "none",
    viewBox: "0 0 677 677"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#272447",
    d: "M556.184 60.878 395.043 222.02c-31.23 31.229-81.856 31.229-113.086 0L120.816 60.878 181.7 0l156.803 156.798L495.306 0zm0 555.244L395.043 454.98c-31.23-31.229-81.856-31.229-113.086 0L120.816 616.122 181.7 677l156.803-156.798L495.306 677zM677 495.306 520.202 338.503 677 181.7l-60.878-60.884L454.98 281.957c-31.229 31.23-31.229 81.856 0 113.086l161.142 161.141zM60.878 556.184 222.02 395.043c31.229-31.23 31.229-81.856 0-113.086L60.878 120.816 0 181.7l156.798 156.803L0 495.306z",
    opacity: 0.3
  })));
};
export default SvgBgImgFull;